import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "toggleButton"]
  static values = { eventId: String, iocCount: Number }

  connect() {
    // After a turbo stream replaces the indicator div, restore "Hide" label
    // if the expanded row already exists in the DOM.
    if (this.#expandedRow) {
      this.#updateToggleText(true)
    }
  }

  toggle() {
    if (this.#expandedRow) {
      this.#close()
    } else {
      this.#open()
    }
  }

  #open() {
    const row = document.createElement("tr")
    row.id = `process-event-ioc-expanded-${this.eventIdValue}`
    const td = document.createElement("td")
    td.setAttribute("colspan", "100")
    td.className = "p-0 border-t-0"
    td.append(...Array.from(this.panelTarget.children))
    row.appendChild(td)
    this.element.closest("tr").insertAdjacentElement("afterend", row)
    this.#updateToggleText(true)
  }

  #close() {
    const row = this.#expandedRow
    if (row) {
      const td = row.querySelector("td")
      if (td) this.panelTarget.append(...Array.from(td.children))
      row.remove()
    }
    this.#updateToggleText(false)
  }

  #updateToggleText(isOpen) {
    if (!this.hasToggleButtonTarget) return

    const count = this.iocCountValue
    const label = count === 1 ? "IoC" : "IoCs"
    this.toggleButtonTarget.textContent = isOpen
      ? `Hide ${count} ${label}`
      : `Show ${count} ${label}`
  }

  get #expandedRow() {
    return document.getElementById(`process-event-ioc-expanded-${this.eventIdValue}`)
  }
}
